import { render, staticRenderFns } from "./UserRoleSelectionInterface.vue?vue&type=template&id=068b39e6"
import script from "./UserRoleSelectionInterface.vue?vue&type=script&lang=js"
export * from "./UserRoleSelectionInterface.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports